import clsx from "clsx"
import Arrow from "../../../assets/icons/arrow.png"
import ImageSkeleton from "../../../components/skeletons/ImageSkeleton";

const ImgSlider = ({ title, imgPath, subtitle, targetId, handleSlide, custCls = "" }) => {
  return (
    <>
      <div className={clsx("pb-20", custCls)}>
        <div className="px-5 sm:px-10 lg:px-20">
          <div className="flex justify-between items-start">
            <div className="w-[87%]">
              <span className="font-agcasmlt text-2xl sm:text-3xl font-light uppercase font-charcoal-black">{title}</span>
            </div>
            <div className="w-[13%]">
              <a href={targetId} onClick={handleSlide}>
                <img width="100" src={Arrow} className="w-full" />
              </a>
            </div>
          </div>
          <a href={targetId} onClick={handleSlide}>
            <div className="w-full h-24 sm:h-36 md:h-44 lg:h-40 mb-2 sm:mb-4 flex items-center justify-center overflow-hidden">
              <ImageSkeleton src={imgPath} alt={subtitle} isDarker custCls="w-full h-full object-cover" />
            </div>
          </a>
          <a href={targetId} onClick={handleSlide} className="font-agcasmlt text-base sm:text-xl leading-6">{subtitle}</a>
        </div>
      </div>
    </>
  )
}

export default ImgSlider